import { Button, Modal, notification } from "antd";
import { deleteComplement } from "api/generated";
import { useClient } from "hooks/useClient";
import { useState } from "react";
import { COMPLEMENT_PARENT } from "./ComplementsScreen";
import { handleAxiosError } from "common/helpers/generalUtils";

interface DeleteComplementProps {
  parentType: COMPLEMENT_PARENT;
  parentId: string;
  onCancel: (reload?: boolean) => void;
}

export default function DeleteComplement({
  parentId,
  onCancel,
  parentType,
}: DeleteComplementProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { client } = useClient();

  function handleOnDelete() {
    setIsLoading(true);
    deleteComplement({
      client,
      path: {
        parentType,
        parentId,
      },
    })
      .then(({ data }) => {
        notification.success({
          message: "Complemento eliminado",
          description: `${data}`,
        });
      })
      .catch((err) =>
        handleAxiosError(err, "No fue posible eliminar el complemento")
      )
      .finally(() => {
        setIsLoading(false);
        onCancel(true);
      });
  }

  return (
    <div>
      <Modal
        open={true}
        title="Atención"
        onCancel={() => {
          onCancel();
        }}
        footer={[
          <Button
            className="back-button"
            key="cancel-delete"
            onClick={() => {
              onCancel();
            }}
          >
            Cancelar
          </Button>,
          <Button
            danger
            type="primary"
            key="delete"
            loading={isLoading}
            onClick={() => {
              handleOnDelete();
            }}
          >
            Confirmar
          </Button>,
        ]}
      >
        <p>
          ¿Está seguro que desea eliminar este complemento? Una vez realizada la
          acción, la información no podrá ser recuperada.
        </p>
      </Modal>
    </div>
  );
}
